import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CitySelectionService {
  readonly leavingFrom$ = new BehaviorSubject<string>('');
  readonly goingTo$ = new BehaviorSubject<string>('');
  readonly travelDate$ = new BehaviorSubject<Date>(new Date());
  readonly returnDate$ = new BehaviorSubject<Date>(new Date());

  setLeavingFrom(city: string): void {
    this.leavingFrom$.next(city);
  }

  setGoingTo(city: string): void {
    this.goingTo$.next(city);
  }

  setTravelDate(date: Date): void {
    this.travelDate$.next(date);
  }

  setReturnDate(date: Date): void {
    this.returnDate$.next(date);
  }
}
